import { render, staticRenderFns } from "./CoreTOS.vue?vue&type=template&id=16a67ac3&"
import script from "./CoreTOS.vue?vue&type=script&lang=js&"
export * from "./CoreTOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports